// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__NARzV","actionsCol":"EnrolledClinics_actionsCol__1cGm5"};